import client from "../../../api/client";

export default async function toggleRoomShortlist(listingId) {
    const response = await client.post(
        `/room-listings/${listingId}/toggle-favourite`
    );
    return response.data;
}